import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";
import { pushSupported, getSubscriptionState, subscribePush, unsubscribePush } from "@/lib/push";

export default function PushToggle() {
  const { t } = useLang();
  const [state, setState] = useState({ supported: false, subscribed: false, permission: "default" });
  const [busy, setBusy] = useState(false);

  const refresh = async () => {
    const s = await getSubscriptionState();
    setState(s);
  };

  useEffect(() => { refresh(); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (state.subscribed) {
        await unsubscribePush();
        toast.success(t("pushOffToast"));
      } else {
        await subscribePush();
        toast.success(t("pushOnToast"));
      }
      await refresh();
    } catch (e) {
      toast.error(t("pushFailed"));
    } finally {
      setBusy(false);
    }
  };

  if (!pushSupported() || !state.supported) return null;

  return (
    <button
      type="button"
      data-testid="push-toggle"
      onClick={toggle}
      disabled={busy}
      className="card-surface w-full p-4 flex items-center gap-3 text-start hover:border-emerald-300 transition"
    >
      <div className={`h-10 w-10 rounded-full grid place-items-center ${state.subscribed ? "bg-emerald-100 text-emerald-700" : "bg-zinc-100 text-zinc-600"}`}>
        {state.subscribed ? <Bell className="h-5 w-5" /> : <BellOff className="h-5 w-5" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">
          {state.subscribed ? t("pushOn") : t("pushEnable")}
        </div>
        <div className="text-xs text-zinc-500">
          {state.permission === "denied"
            ? t("pushBlocked")
            : state.subscribed
            ? t("pushTapDisable")
            : t("pushGetNotified")}
        </div>
      </div>
    </button>
  );
}
